export const resetFieldsFromMap = (
    fieldMap: Record<string, any>,
    setFieldValue: (field: string, value: any) => void,
    resetValue: any = ''
): void => {
    Object.keys(fieldMap).forEach(field => {
        setFieldValue(field, resetValue);
    });
};
